/*
pagesegmode values are:
0 = Orientation and script detection (OSD) only.
1 = Automatic page segmentation with OSD.
2 = Automatic page segmentation, but no OSD, or OCR
3 = Fully automatic page segmentation, but no OSD. (Default)
4 = Assume a single column of text of variable sizes.
5 = Assume a single uniform block of vertically aligned text.
6 = Assume a single uniform block of text.
7 = Treat the image as a single text line.
8 = Treat the image as a single word.
9 = Treat the image as a single word in a circle.
10 = Treat the image as a single character.
*/
//https://www.ttmind.com/techpost/how-to-extract-text-from-image-using-angularocr-with-tessera
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, DoCheck } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import { DatePipe } from '@angular/common';
//snackbar 1
import { MatSnackBar } from '@angular/material';
//ngx-webcam 1
import { Subject } from 'rxjs';
import { WebcamUtil } from 'ngx-webcam';
import { environment } from "environments/environment";
import { createWorker } from 'tesseract.js';
//import { NgQrScannerModule } from 'angular2-qrscanner';
//qr 1
import { QrScannerComponent } from 'angular2-qrscanner';
var CGComponent = /** @class */ (function () {
    function CGComponent(snackBar, datePipe, 
    //spellcheck3
    //private spellCheckerService: SpellCheckerService,
    httpClient) {
        this.snackBar = snackBar;
        this.datePipe = datePipe;
        this.httpClient = httpClient;
        //spellcheck2
        this.fileURL = "https://raw.githubusercontent.com/JacobSamro/ngx-spellchecker/master/dict/normalized_en-US.dic";
        this.ocrResult = 'Pulse SCAN para reconocer..';
        this.Result = 'Recognizing...';
        this.res = [];
        //ngx-webcam 2
        // toggle webcam on/off
        this.showWebcam = true;
        this.allowCameraSwitch = true;
        this.multipleWebcamsAvailable = false;
        this.videoOptions = {};
        this.errors = [];
        // latest snapshot
        this.webcamImage = null;
        // webcam snapshot trigger
        this.trigger = new Subject();
        // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
        this.nextWebcam = new Subject();
        this.getQr = 'noget';
        this.uploader = new FileUploader({
            url: environment.backendUrl + "/api/importador/importar",
            itemAlias: 'foto',
            headers: [{ name: 'Access-Control-Allow-Origin', value: '*' }]
        });
        this.objdevices = [];
    }
    CGComponent.prototype.ngDoCheck = function () {
        //console.log(this.ocrResult);
        //console.log(this.getQr);
        //const videoDevices: MediaDeviceInfo[] = [];
        //console.log(videoDevices.length + " camaras..");
        //console.log("docheckcuentacamaras");
        //console.log(JSON.stringify(this.objdevices));
    };
    /*
      spellChecker(){
        this.httpClient.get(this.fileURL, { responseType: 'text' }).subscribe((res: any) => {
          let dictionary = this.spellCheckerService.getDictionary(res)
          console.log(dictionary.spellCheck("test"))
        });
      }
    */
    CGComponent.prototype.scan = function () {
        document.getElementById("botonScan").click();
    };
    CGComponent.prototype.borraDatos = function () {
        this.getQr = 'noget';
        this.ocrResult = 'recognizing text';
        this.importeok = null;
        this.totalok = null;
        this.fechaok = null;
        this.loading = false;
    };
    CGComponent.prototype.getQR = function () {
        var _this = this;
        //qr 3
        this.qrScannerComponent.getMediaDevices().then(function (devices) {
            console.log(devices);
            var videoDevices = [];
            for (var _i = 0, devices_1 = devices; _i < devices_1.length; _i++) {
                var device = devices_1[_i];
                if (device.kind.toString() === 'videoinput') {
                    videoDevices.push(device);
                }
            }
            if (videoDevices.length > 0) {
                var choosenDev = void 0;
                for (var _a = 0, videoDevices_1 = videoDevices; _a < videoDevices_1.length; _a++) {
                    var dev = videoDevices_1[_a];
                    if (dev.label.includes('back')) {
                        choosenDev = dev;
                        console.log("CHOOSENDEV: " + choosenDev);
                        break;
                    }
                }
                if (choosenDev) {
                    _this.qrScannerComponent.chooseCamera.next(choosenDev);
                }
                else {
                    _this.qrScannerComponent.chooseCamera.next(videoDevices[0]);
                }
                _this.camara = videoDevices[0].label;
                console.log(videoDevices[0]);
                console.log(_this.camara);
            }
        });
        this.qrScannerComponent.capturedQr.subscribe(function (result) {
            console.log(result);
            _this.getQr = result;
            document.getElementById("cerrarModalQR").click();
        }, function (error) {
            console.log(error);
            document.getElementById("cerrarModalQR").click();
            _this.errorqr = error;
        });
    };
    CGComponent.prototype.changeCam = function () {
        var _this = this;
        //qr 3
        this.qrScannerComponent.getMediaDevices().then(function (devices) {
            console.log(devices);
            var videoDevices = [];
            for (var _i = 0, devices_2 = devices; _i < devices_2.length; _i++) {
                var device = devices_2[_i];
                if (device.kind.toString() === 'videoinput') {
                    videoDevices.push(device);
                }
            }
            if (videoDevices.length > 0) {
                var choosenDev = void 0;
                for (var _a = 0, videoDevices_2 = videoDevices; _a < videoDevices_2.length; _a++) {
                    var dev = videoDevices_2[_a];
                    if (dev.label.includes('back')) {
                        choosenDev = dev;
                        console.log("CHOOSENDEV: " + choosenDev);
                        break;
                    }
                }
                if (choosenDev) {
                    _this.qrScannerComponent.chooseCamera.next(choosenDev);
                }
            }
        });
    };
    CGComponent.prototype.mostrarTexto = function () {
        $("#ModalWarning").show();
        /*
        $("#ModalWarning").on('hidden.bs.modal', function(){
          //alert("Hello World!");
        });
        */
    };
    //to async mode
    CGComponent.prototype.reconocer = function () {
        var _this = this;
        this.loading = true;
        Tesseract.recognize(this.fotodetalle, 'spa', 'SPARSE_TEXT').progress(function (progress) {
            //console.log(progress, "$$$$");
            if (progress.status === "recognizing text") {
                $('#progress').text(Math.round(progress.progress * 100) + '%');
                _this.ocrResult = progress.status;
            }
        }).then(function (result) {
            //$('#result').text(result.text);
            console.log(result);
            console.log(result.blocks[0]["words"][0]["text"]);
            _this.ocrResult = result.text.toString();
            _this.getDatos();
            _this.loading = false;
        });
    };
    CGComponent.prototype.getPos = function () {
        var loro = "\n      LEONARDI DIEGO ALEJANDRO c010: 20-20320402-1 INGRESOS 000003: 1147875'06 > Av. ensues 2706 \n      - C.A.B.A. IVA 00500030000 INSCRIPTO 0 0003001000 FINAL. _, P.V.:UOU3 00:01 N0.T:00002972  \n      x \u2018 13/01/2020 07:20 \u2018 - x .   \u2018 \u2018 6X 550,00 0,  \u201D GOLOSINAS 3.300, 00 3% .\n       :17'6'17313\u2018\"\u201Dmm\u2014733007000\u201801\u201C}, 9 _ . EFEC'I\u2018IVO 3.30000 \u201C1.0;.\u201D 0 . CANT. ITEMS : 1 \u201D[2,! Jr .         $ELEE\u00E9~a\uFB01\u00A7R\"'g_ $030? \u201830 \u2018c\u00E9\uFB01goni\u2018b\u2018g\uFB01 ; \u2018 \u2019 *\u2018 .. \uFB01st-$052939; ,;v,i:/r ' \n         3 \u2018~\\ -Wn. _, \u201D80' \u2018 , \u2018 \u2018 m? ; \u00ABMy U \u00BB 0 ,  .021\u201D ,'  _ . _ y . a:'~\u2018r=.\u00A7F~.::,. \" '\n          _\u2018 , \u201813: \u20187\u2018; . '\n      ";
        //this.posi = loro.search("fecha"); // devuelve 76
        this.posi = loro.indexOf("fecha");
        console.log(this.posi);
        console.log("FECHA: " + loro.slice(this.posi, this.posi + 16));
        //console.log("FECHA: " + loro.slice(this.posi, this.posi + 16));
    };
    CGComponent.prototype.getDatos = function () {
        var str = this.ocrResult.toString();
        /*
        `
        LEONARDI DIEGO ALEJANDRO c010: 20-20320402-1 INGRESOS 000003: 1147875'06 > Av. ensues 2706
        - C.A.B.A. IVA 00500030000 INSCRIPTO 0 0003001000 FINAL. _, P.V.:UOU3 00:01 N0.T:00002972 \
        x ‘ 13/01/2020 07:20 ‘\ - x . \ \ ‘ ‘ 6X 550,00 0, \ ” GOLOSINAS 3.300, 00 3% .
         :17'6'17313‘"”mm—733007000‘01“}, 9 _ . EFEC'I‘IVO 3.30000 “1.0;.” 0 . CANT. ITEMS : 1 ”[2,! Jr .\
           $ELEEé~aﬁ§R"'g_ $030? ‘30 ‘céﬁgoni‘b‘gﬁ ; ‘ ’ *‘ .. ﬁst-$052939; ,;v,i:/r '
           3 \‘~\\ -Wn. _, ”80' ‘ , ‘ ‘ m? ; «My U » 0 , \ .021” ,' \ _ . _ y . a:'~‘r=.§F~.::,. " '
            _‘ , ‘13: ‘7‘; . '
        `;
        */
        var fecha = str.match(/(\d{2}([.\-/])\d{1,2}([.\-/])\d{4})|(\d{4}([.\-/])\d{1,2}([.\-/])\d{2})/g);
        console.log("date recognized= " + fecha);
        // 1. busco por string la similitud y obtengo la posicion.
        var postot = str.indexOf("EFEC");
        var postotal = str.indexOf("TOTAL");
        // 2. extraigo los proximos 20 caracteres desde la posicion indicada
        var totstr = str.slice(postot, postot + 20);
        var totalstr = str.slice(postotal, postotal + 25);
        // 3. match regex para extraer lo que necesito..
        var tot = totstr.match(/\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?/);
        var totale = totalstr.match(/\d+\.\d{1,2}/);
        //loro.match(/(TOT|EFEC|tot|efec)/);
        console.log("efect utilizado: " + totstr);
        console.log("total supuesto: " + totalstr);
        this.fechaok = fecha;
        try {
            this.importeok = parseFloat(tot.toString());
            this.importeok = this.importeok * 1000;
            console.log("efec parseado: $" + this.importeok);
        }
        catch (error) {
            console.log("ERROR AL PARSEAR efec: '" + error + "'");
        }
        try {
            this.totalok = parseFloat(totale.toString());
            console.log("total parseado: $" + this.totalok);
        }
        catch (error) {
            console.log("ERROR AL PARSEAR total: '" + error + "'");
        }
    };
    CGComponent.prototype.borraBasura = function () {
        var str = "\n      LEONARDI DIEGO ALEJANDRO c010: 20-20320402-1 INGRESOS 000003: 1147875'06 > Av. ensues 2706 \n      - C.A.B.A. IVA 00500030000 INSCRIPTO 0 0003001000 FINAL. _, P.V.:UOU3 00:01 N0.T:00002972  \n      x \u2018 13/01/2020 07:20 \u2018 - x .   \u2018 \u2018 6X 550,00 0,  \u201D GOLOSINAS 3.300, 00 3% .\n       :17'6'17313\u2018\"\u201Dmm\u2014733007000\u201801\u201C}, 9 _ . EFEC'I\u2018IVO 3.30000 TOTAL 3.30000 \u201C1.0;.\u201D 0 . CANT. ITEMS : 1 \u201D[2,! Jr .         3 \u2018~\\ -Wn. _, \u201D80' \u2018 , \u2018 \u2018 m? ; \u00ABMy U \u00BB 0 ,  .021\u201D ,'  _ . _ y . a:'~\u2018r=.\u00A7F~.::,. \" '\n          _\u2018 , \u201813: \u20187\u2018; . '\n      ";
        console.log(str);
        console.log(str.length + " chars");
        //var sinbasura = str.replace(/'I‘/g, "T");
        //console.log(sinbasura);
        //console.log(sinbasura.length + " chars");
        var fecha = str.match(/(\d{1,4}([.\])\d{1,2}([.\-/])\d{1,4})/g);
        console.log("date recognized= " + fecha);
        var postot = str.indexOf("EFEC");
        var postotal = str.indexOf("TOTAL");
        var totstr = str.slice(postot, postot + 20);
        var totalstr = str.slice(postotal, postotal + 20);
        var tot = totstr.match(/\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?/);
        var totale = totalstr.match(/\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{2})?/);
        //loro.match(/(TOT|EFEC|tot|efec)/);
        console.log("string utilizado: " + totstr);
        console.log("total supuesto: " + tot);
        console.log("total supuesto2: " + totale);
        this.fechaok = fecha;
        this.importeok = parseFloat(tot.toString());
        this.importeok = this.importeok * 1000;
    };
    CGComponent.prototype.recognizeTo = function () {
        this.ocrResult = 'Reconociendo..';
        this.loading = true;
        this.doOCR();
    };
    CGComponent.prototype.doOCR = function () {
        return __awaiter(this, void 0, void 0, function () {
            var worker, respuesta;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        worker = createWorker({
                            logger: function (m) { return console.log(m); },
                        });
                        return [4 /*yield*/, worker.load()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, worker.loadLanguage('spa')];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, worker.initialize('spa')];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, worker.recognize(this.fotodetalle)];
                    case 4:
                        respuesta = _a.sent();
                        this.ocrResult = respuesta.data.text.toString();
                        console.log(this.ocrResult);
                        return [4 /*yield*/, worker.terminate()];
                    case 5:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    CGComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userlog = localStorage.getItem("userId");
        ////ngx-webcam 2
        WebcamUtil.getAvailableVideoInputs()
            .then(function (mediaDevices) {
            _this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
        //reconocer camaras
        var videoDevices = [];
        this.qrScannerComponent.getMediaDevices().then(function (devices) {
            //console.log(devices);
            var videoDevices = [];
            for (var _i = 0, devices_3 = devices; _i < devices_3.length; _i++) {
                var device = devices_3[_i];
                if (device.kind.toString() === 'videoinput') {
                    videoDevices.push(device);
                    _this.objdevices.push(device);
                    console.log(device);
                    console.log("paso x el for device");
                }
            }
        });
        console.log("dispo encontrados..");
        console.log(JSON.stringify(this.objdevices));
        //cambiar a camara trasera..
        this.changeCam();
    };
    CGComponent.prototype.apagaCamara = function () {
    };
    CGComponent.prototype.subirImagenDesdePc = function () {
        this.fotodetalle = this.fotob64;
        console.log("resize imagen subida deshabilitado");
        this.fotodetalle = this.fotodetalle;
    };
    CGComponent.prototype.getFiles = function (event) {
        this.files = event.target.files;
        var reader = new FileReader();
        reader.onload = this._handleReaderLoaded.bind(this);
        reader.readAsDataURL(this.files[0]);
    };
    //obtengo base64 de imagen subida
    CGComponent.prototype._handleReaderLoaded = function (readerEvt) {
        var b64String = readerEvt.target.result;
        this.fotob64 = b64String;
        //console.log(this.fotob64);
    };
    CGComponent.prototype.snackCamara = function () {
        // snackbar si encuentra al usuario
        this.snackBar.open('IMAGEN LISTA!!!', 'Cerrar', { duration: 3000 });
        //document.getElementById("botonScan").click();
    };
    CGComponent.prototype.test = function () {
        this.loading = true;
        Tesseract.recognize("" + this.fotodetalle).then(function (result) {
            //alert(result.text);      
            console.log(result.text);
            console.log(result);
            localStorage.setItem("ocr", result.text);
        });
        this.loading = false;
        this.Result = localStorage.getItem("ocr");
        console.log(this.Result);
    };
    //ngx-webcam 3
    CGComponent.prototype.triggerSnapshot = function () {
        this.trigger.next();
    };
    CGComponent.prototype.toggleWebcam = function () {
        this.showWebcam = !this.showWebcam;
    };
    CGComponent.prototype.handleInitError = function (error) {
        this.errors.push(error);
    };
    CGComponent.prototype.showNextWebcam = function (directionOrDeviceId) {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    };
    CGComponent.prototype.handleImage = function (webcamImage) {
        console.info('received webcam image', webcamImage);
        this.webcamImage = webcamImage;
        //console.log(this.webcamImage.imageAsDataUrl);
        //hago el resize de la fotodetalle antes de guardarlo
        console.log("resize imagen desde webcam..");
        this.fotodetalle = this.webcamImage.imageAsDataUrl;
    };
    CGComponent.prototype.cameraWasSwitched = function (deviceId) {
        console.log('active device: ' + deviceId);
        this.deviceId = deviceId;
    };
    Object.defineProperty(CGComponent.prototype, "triggerObservable", {
        get: function () {
            return this.trigger.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CGComponent.prototype, "nextWebcamObservable", {
        get: function () {
            return this.nextWebcam.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    CGComponent.prototype.limpiacam = function () {
        this.showWebcam = false;
        this.fotodetalle = [];
        this.fotodetalle = null;
        this.webcamImage = null;
    };
    // fin ngx-webcam 
    CGComponent.prototype.prendeCamara = function () {
        //prende ngx-webcam 4
        this.showWebcam = true;
    };
    CGComponent.prototype.quitarImagen = function () {
        this.fotodetalle = null;
        this.limpiacam();
        this.sumi = 0;
    };
    return CGComponent;
}());
export { CGComponent };
